"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBText = require("../HBText/HBText.styles");
var _styledIs = _interopRequireDefault(require("styled-is"));
var _templateObject;
var _excluded = ["children", "linkButtonTheme", "textTransform", "alignment"];
var HBLinkButton = function HBLinkButton(_ref) {
  var children = _ref.children,
    _ref$linkButtonTheme = _ref.linkButtonTheme,
    linkButtonTheme = _ref$linkButtonTheme === void 0 ? 'accent' : _ref$linkButtonTheme,
    _ref$textTransform = _ref.textTransform,
    textTransform = _ref$textTransform === void 0 ? 'capitalize' : _ref$textTransform,
    alignment = _ref.alignment,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledHBButton, (0, _extends2["default"])({}, props, THEME_PROPS[linkButtonTheme], {
    textTransform: textTransform,
    $alignment: alignment
  }), children);
};
var _default = exports["default"] = HBLinkButton;
var StyledHBButton = (0, _styledComponents["default"])(_HBButton["default"]).withConfig({
  displayName: "HBLinkButton__StyledHBButton",
  componentId: "sc-g41r60-0"
})(["height:fit-content;padding:0;", " ", ""], function (_ref2) {
  var size = _ref2.size;
  return SIZE_PROPS[size];
}, (0, _styledIs["default"])('$alignment')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        justify-content: ", ""])), function (_ref3) {
  var $alignment = _ref3.$alignment;
  return $alignment === 'start' ? 'flex-start' : $alignment === 'end' ? 'flex-end' : 'center';
}));
var THEME_PROPS = {
  accent: {
    buttonTheme: 'button-link-blue',
    loaderColor: _colors["default"].blue20
  },
  neutral: {
    buttonTheme: 'link-button-neutral'
  },
  solid: {
    buttonTheme: 'button-link-solid'
  },
  secondary: {
    buttonTheme: 'button-link-secondary'
  },
  'link-button-accent': {
    buttonTheme: 'link-button-accent'
  }
};
var SIZE_PROPS = {
  sm: _HBText.newTextStyles.emphasis14,
  md: _HBText.newTextStyles.emphasis16,
  lg: _HBText.newTextStyles.emphasis18
};
//# sourceMappingURL=HBLinkButton.js.map